import { faUserEdit, faUserTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Modal, Button } from "react-bootstrap";
import UserFormModal from "./UserFormModal";

export default class MobileInfoModal extends React.Component {
  state = {
    newUser: {},
  };
  determineWhichUpdateUserToDisplayAndDisplay(activeEmployee) {
    if (
      activeEmployee.userBusinessUnit === "Kansas City" ||
      activeEmployee.userBusinessUnit === "Minnesota" ||
      activeEmployee.userBusinessUnit === "Silicon Valley" ||
      activeEmployee.userBusinessUnit === "Northern Virginia"
    ) {
      this.setState({ showDynamicUpdateUserModal: true, currentEditEmployee: activeEmployee });
      this.setState({ dynamicUpdateUserType: "NotFranchise" });
    } else {
      this.setState({ showDynamicUpdateUserModal: true, currentEditEmployee: activeEmployee });
      this.setState({ dynamicUpdateUserType: "Franchise" });
    }
  }
  render() {
    return (
      <div>
        {this.props.employee && (
          <Modal
            show={this.props.show}
            onHide={this.props.onHide}
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                User Details for {this.props.employee.userFullName}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="row justify-content-center">
                <div className="col-lg text-center">
                  <strong>User Full Name</strong>
                  <input
                    type="text"
                    className={`text-center w-100`}
                    name="addUserRequestFullName"
                    value={this.props.employee.userFullName}
                    disabled={true}
                  />
                </div>
                <div className="col-lg text-center">
                  <strong>Employee Email</strong>
                  <input
                    type="text"
                    className={`text-center w-100`}
                    name="addUserRequestJobTitle"
                    value={this.props.employee.userPrimaryEmail}
                    disabled={true}
                  />
                </div>
                <div className="col-lg text-center">
                  <strong>User Job Title</strong>
                  <input
                    type="text"
                    className={`text-center w-100`}
                    name="addUserRequestJobTitle"
                    value={this.props.employee.userJobTitle}
                    disabled={true}
                  />
                </div>
                <div className="col-lg text-center">
                  <strong>Business Unit</strong>
                  <input
                    type="text"
                    className={`text-center w-100`}
                    name="addUserRequestJobTitle"
                    value={this.props.employee.userBusinessUnit}
                    disabled={true}
                  />
                </div>
                <div className="col-lg text-center">
                  <strong>License Bundle</strong>
                  <input
                    type="text"
                    className={`text-center w-100`}
                    name="addUserRequestJobTitle"
                    value={this.props.employee.userBundleName}
                    disabled={true}
                  />
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
              <Button
                data-testid="delete-modal-no-button"
                variant="warning"
                size="lg"
                onClick={() => this.determineWhichUpdateUserToDisplayAndDisplay(this.props.employee)}
              >
                <FontAwesomeIcon icon={faUserEdit} /> Update User
              </Button>
              <Button
                data-testid="delete-modal-delete-button"
                variant="danger"
                size="lg"
                onClick={() =>
                  this.setState({ showRemoveUserFormModal: true, currentEditEmployee: this.props.employee })
                }
              >
                <FontAwesomeIcon icon={faUserTimes} /> Remove User
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        <UserFormModal
          mode="remove"
          show={this.state.showRemoveUserFormModal}
          onHide={() => this.setState({ showRemoveUserFormModal: false })}
          employee={this.state.currentEditEmployee}
          usersList={this.state.employeeList}
          notifyFranchisee={this.state.notifyFranchisee}
          requester={this.props.crmUser}
        />
        <UserFormModal
          mode="update"
          show={this.state.showDynamicUpdateUserModal}
          onHide={() => this.setState({ showDynamicUpdateUserModal: false })}
          employee={this.state.currentEditEmployee}
          requester={this.props.crmUser}
          typeOfModal={this.state.dynamicUpdateUserType}
        />
      </div>
    );
  }
}
